import React from "react";
import { Select } from "antd";
import { ALL_LANGUAGES, COMMON_LANGUAGES_COUNT, getDeprecatedLanguageOption } from "../../constant/languages";

const { Option } = Select;

const PREFERRED_LANGUAGE_DIVIDER = "--------------------------------------";

// Builds the <Option> children for a Preferred Language <Select>: a display-only option for a
// record whose language was deprecated (injected only when it matches the current value), the
// full language list, and the disabled divider after the common-languages group.
// Call it inline inside <Select> — it returns a fragment of <Option>s, which antd flattens. Do
// not render it as a component element inside <Select>; antd only treats Option/OptGroup (and
// fragments/arrays) as real options.
// dividerLabel defaults to the wide divider; pass a shorter one for narrow inline selects.
export const renderPreferredLanguageOptions = (preferredLanguage, dividerLabel = PREFERRED_LANGUAGE_DIVIDER) => {
  const deprecatedLanguageOption = getDeprecatedLanguageOption(preferredLanguage);

  return (
    <>
      {deprecatedLanguageOption && (
        <Option value={deprecatedLanguageOption.value}>{deprecatedLanguageOption.label}</Option>
      )}
      {ALL_LANGUAGES.map((p, index) => (
        <React.Fragment key={p.value}>
          <Option value={p.value}>{p.label}</Option>
          {index === COMMON_LANGUAGES_COUNT - 1 && (
            <Option disabled key="divider" style={{ cursor: "default" }}>
              {dividerLabel}
            </Option>
          )}
        </React.Fragment>
      ))}
    </>
  );
};
